import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicHeader from "../../components/PublicHeader";
import SiteFooter from "../../components/SiteFooter";
import { api } from "../../lib/api";
import { ArrowRight } from "lucide-react";

export default function Confirmation() {
  const { id } = useParams();
  const [ev, setEv] = useState(null);

  useEffect(() => {
    if (!id) return;
    api.get(`/events/${id}/summary`).then((r) => setEv(r.data)).catch(() => {});
  }, [id]);

  const pub = ev?.publication === "dwt" ? "dwt" : ev?.publication === "dwh" ? "dwh" : null;
  const notThisTime = ev?.status === "not_this_time";

  useEffect(() => {
    if (pub) document.documentElement.dataset.pub = pub;
    return () => { delete document.documentElement.dataset.pub; };
  }, [pub]);

  return (
    <div className="min-h-screen bg-[#f5f3ed] flex flex-col" data-testid="confirmation-page" data-pub={pub || "neutral"}>
      <PublicHeader pub={pub} />
      <main className="w-full max-w-2xl mx-auto px-6 sm:px-10 pt-16 pb-24 flex-1">
        {notThisTime ? (
          <>
            <p className="btw-step-label mb-3">An update on your story</p>
            <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-6">
              Thank you for sharing your story with us.
            </h1>
            <p className="text-sm text-black leading-relaxed max-w-md mb-10" data-testid="gentle-message">
              This one isn't the right fit for our pages this time. We truly loved reading
              it — and we'd love to hear from you again with a future story.
            </p>
          </>
        ) : (
          <>
            <p className="btw-step-label mb-3">Submission received</p>
            <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-6">
              We're looking forward to reading all about this one
            </h1>
            <p className="text-sm text-black leading-relaxed max-w-md mb-10">
              Thank you. Our team will review your story, create your published
              credits and let your vendors know they were named.
            </p>
          </>
        )}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
          <Link to="/my-submissions" className="btw-btn-outline justify-center" data-testid="my-submissions-link">
            My submissions
          </Link>
          <Link to="/create-event" className="btw-btn" data-testid="back-link">
            <span>Submit another story</span>
            <span className="btw-btn-arrow"><ArrowRight size={12} /></span>
          </Link>
        </div>
      </main>
      <SiteFooter pub={pub} />
    </div>
  );
}
